import React, { useState, useEffect, useRef } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './Home';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
